document.addEventListener("DOMContentLoaded", function () {
  function updateUpsellTitle() {
    // Cerca l'elemento #revy-bundles-wrapper
    const revyWrapper = document.getElementById("revy-bundles-wrapper");

    if (revyWrapper) {
      // Cerca l'elemento con attributo data-title-upsell
      const upsellElements = document.querySelectorAll(
        ".product__complementaries [data-title-upsell], .highlighted-product [data-title-upsell]"
      );

      if (upsellElements.length > 0) {
        upsellElements.forEach((upsellElement, index) => {
          const upsellText = upsellElement.getAttribute("data-title-upsell");

          if (upsellText && upsellText.trim() !== "") {
            upsellElement.textContent = upsellText;
          }
        });
      }
    }
  }

  // Esegui immediatamente
  updateUpsellTitle();

  // Observer per elementi iniettati dinamicamente
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // Element node
          // Controlla se il nodo aggiunto è #revy-bundles-wrapper o lo contiene
          if (
            node.id === "revy-bundles-wrapper" ||
            (node.querySelector && node.querySelector("#revy-bundles-wrapper"))
          ) {
            setTimeout(updateUpsellTitle, 100); // Piccolo delay per assicurarsi che sia completamente caricato
          }
        }
      });
    });
  });

  // Osserva tutto il documento per cambiamenti
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Controllo periodico per i primi 10 secondi (fallback per script asincroni)
  let attempts = 0;
  const maxAttempts = 3;
  const intervalId = setInterval(() => {
    attempts++;
    updateUpsellTitle();
    if (attempts >= maxAttempts) {
      clearInterval(intervalId);
    }
  }, 2000);
});
